import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Calculator',
    component: () => import('../views/Calculator.vue'),
    meta: { title: 'Pricing Calculator' }
  },
  {
    path: '/pricing-info',
    name: 'TransparentPricing',
    component: () => import('../views/TransparentPricing.vue'),
    meta: { title: 'Transparent Decoration Pricing' }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: { title: 'Page Not Found' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach((to, _from, next) => {
  document.title = to.meta.title || 'Pricing Calculator'
  next()
})

export default router
